import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const GlobalCss = withStyles({
  '@global': {
    '.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiInputLabel-outlined.Mui-disabled': {
      fontWeight: 700,
    },
    '.MuiOutlinedInput-input.Mui-disabled': {
      paddingTop: '12px',
    },
  },
})(() => null);

interface TextProp {
  label: string;
  meta: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
  input: object;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
}

const Text = ({
  label,
  input,
  disabled,
  meta: { touched, invalid, error },
  ...props
}: TextProp) => (
  <>
    {disabled && <GlobalCss />}
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      disabled={disabled}
      {...input}
      {...props}
    />
  </>
);

export default Text;
